import {
  Activity03HugeIcon,
  AddSquareHugeIcon,
  Airplane02HugeIcon,
  Alert01HugeIcon,
  AlertDiamondHugeIcon,
  AnalysisTextLinkHugeIcon,
  Analytics01HugeIcon,
  Archive02HugeIcon,
  ParagraphBulletsPoint02HugeIcon,
  ComplaintHugeIcon,
  CottageHugeIcon,
  HajjHugeIcon,
  Kaaba01HugeIcon,
  LicenseHugeIcon,
  LicenseThirdPartyHugeIcon,
  Location03HugeIcon,
  ManagerHugeIcon,
  MosqueHugeIcon,
  PolicyHugeIcon,
  RealEstateHugeIcon,
  ScrollHugeIcon,
  SearchAreaHugeIcon,
  SecurityCheckHugeIcon,
  SeoHugeIcon,
  ServiceHugeIcon,
  Settings01HugeIcon,
  SquareArrowDataTransferDiagonalHugeIcon,
  StoreVerifiedHugeIcon,
  UserGroup03HugeIcon,
  UserIdVerificationHugeIcon,
  ValidationApprovalHugeIcon,
  WorkAlertHugeIcon,
  UserUnlock01HugeIcon,
  CampaignsHugeIcon,
  GroupsHugeIcon,
  QuestionHugeIcon,
  Briefcase06HugeIcon,
} from "../../Data/svgIcons";
import usePermissions from "@/utils/hooks/usePermissions";
import { ROLES, permissions } from "@/utils/constants";
import { useMemo } from "react";

export const useMenuItems = () => {
  const {
    hasAnyPermission
  } = usePermissions()

  // Icons can be added to menu items - if undefined, pseudo-element styles will be used
  const MakkahMenuItems = useMemo(() => [
    {
      menutitle: "MAKKAH_DASHBOARD",
      Items: [
        hasAnyPermission([permissions.view_planning]) && {
          title: "PLANNING_AND_PREPARATION",
          type: "sub",
          badge: true,
          active: false,
          children: [
            hasAnyPermission([permissions.view_organizers]) && {
              title: "ORGANIZERS_AND_CONTRACTS",
              path: `/app/makkah/organizers-and-contracts`,
              type: "link",
              icon: ServiceHugeIcon,
            },
            hasAnyPermission([permissions.view_visas]) && {
              title: "VISAS",
              path: `/app/makkah/visas`,
              type: "link",
              icon: ValidationApprovalHugeIcon,
            },
            hasAnyPermission([
              permissions.list_campaigns,
              permissions.view_campaigns,
              permissions.create_campaigns,
              permissions.update_campaigns,
              permissions.delete_campaigns,
              permissions.list_campaign_details,
              permissions.view_campaign_details,
              permissions.create_campaign_details,
              permissions.update_campaign_details,
              permissions.delete_campaign_details,
              permissions.list_departure_campaigns,
              permissions.view_departure_campaigns,
              permissions.create_departure_campaigns,
              permissions.update_departure_campaigns,
              permissions.delete_departure_campaigns,
              permissions.list_departure_campaign_details,
              permissions.view_departure_campaign_details,
              permissions.create_departure_campaign_details,
              permissions.update_departure_campaign_details,
              permissions.delete_departure_campaign_details,
            ]) && {
              title: "CAMPAIGNS",
              path: hasAnyPermission([
                permissions.list_campaigns,
                permissions.view_campaigns,
                permissions.create_campaigns,
                permissions.update_campaigns,
                permissions.delete_campaigns,
                permissions.list_campaign_details,
                permissions.view_campaign_details,
                permissions.create_campaign_details,
                permissions.update_campaign_details,
                permissions.delete_campaign_details,
              ])
                ? `/app/makkah/arrival-campaign?source=arrival-campaign`
                : `/app/makkah/departure-campaign?source=departure-campaign`,
              type: "link",
              icon: CampaignsHugeIcon,
            },
            hasAnyPermission([
              permissions.list_groups,
              permissions.view_groups,
              permissions.create_groups,
              permissions.update_groups,
              permissions.delete_groups,
              permissions.list_group_details,
              permissions.view_group_details,
              permissions.create_group_details,
              permissions.update_group_details,
              permissions.delete_group_details,
            ]) && {
              title: "GROUPS",
              path: `/app/makkah/groups-upcoming`,
              type: "link",
              icon: GroupsHugeIcon,
            },
            hasAnyPermission([permissions.view_camps]) && {
              title: "CAMPS",
              path: `/app/makkah/camps`,
              type: "link",
              icon: CottageHugeIcon,
            },
            hasAnyPermission([permissions.view_compliance]) && {
              title: "COMPLIANCE",
              path: `/app/makkah/compliance`,
              type: "link",
              icon: PolicyHugeIcon,
            },
          ].filter(Boolean),
        },
        hasAnyPermission([permissions.list_port_reception_cards_from_missions, permissions.list_port_reception_cards_from_nask]) && {
          title: "RECEPTIONـOFـPORTS",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            hasAnyPermission([permissions.list_port_reception_cards_from_missions, permissions.list_port_reception_cards_from_nask]) && {
              title: "RECEPTION_MAKKAH",
              path: `/app/makkah/JED/reception`,
              type: "link",
              icon: RealEstateHugeIcon,
            },
          ].filter(Boolean),
        },
        hasAnyPermission([
          permissions.list_center_reception_cards_from_ports,
          permissions.list_center_reception_cards_between_cities,
          permissions.list_makkah_reception_manifests,
          permissions.list_makkah_reception_manifest_pilgrims,
          permissions.list_makkah_reception_tafweejs,
          permissions.list_makkah_reception_tafweej_pilgrims,
        ]) && {
          title: "CENTER_RECEPTION",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            hasAnyPermission([permissions.list_center_reception_cards_from_ports, permissions.list_center_reception_cards_between_cities]) && {
              title: "CENTER_RECEPTION_MAKKAH_ORGANIZER",
              path: `/app/makkah/JED/center-reception`,
              type: "link",
              icon: RealEstateHugeIcon,
            },
            hasAnyPermission([
              permissions.list_makkah_reception_manifests,
              permissions.list_makkah_reception_manifest_pilgrims,
              permissions.list_makkah_reception_tafweejs,
              permissions.list_makkah_reception_tafweej_pilgrims,
            ]) && {
              title: "NUSUK_RECEPTION_MAKKAH",
              path: `/app/makkah/MED/center-reception?source=from_ports&date=today`,
              type: "link",
              icon: MosqueHugeIcon,
            },
          ].filter(Boolean),
        },
        // السكن و المساكن
        hasAnyPermission([
          permissions.list_housing,
          permissions.list_housing_contracts,
          permissions.list_house_inspection_examinations,
          permissions.list_house_inspection_orders,
          permissions.view_house_inspection_results,
          permissions.list_house_inspection_examination_periods,
        ]) && {
          title: "HOUSING_AND_ACCOMMODATIONS",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            // المساكن
            hasAnyPermission([permissions.list_housing]) && {
              title: "HOUSING",
              path: `/app/makkah/housing-permits`,
              type: "link",
              icon: LicenseThirdPartyHugeIcon,
            },
            // عقود السكن
            hasAnyPermission([permissions.list_housing_contracts]) && {
              title: "HOUSING_CONTRACTS",
              path: `/app/makkah/housing-contracts`,
              type: "link",
              icon: ScrollHugeIcon,
            },
            //فحص جاهزية السكن
            hasAnyPermission([permissions.list_house_inspection_examinations]) && {
              title: "HOUSING_INSPECTION",
              path: `/app/makkah/housing-inspection`,
              type: "link",
              icon: StoreVerifiedHugeIcon,
            },
            // اوامر فحص السكن
            hasAnyPermission([permissions.list_house_inspection_orders]) && {
              title: "HOUSING_INSPECTION_MONITORING",
              path: `/app/makkah/housing-inspection-orders`,
              type: "link",
              icon: SearchAreaHugeIcon,
            },
            // ملاحظات فحص السكن
            hasAnyPermission([permissions.view_house_inspection_results]) && {
              title: "FOLLOW_UP_READINESS_REPORTS",
              path: `/app/makkah/housing-inspection-notes`,
              type: "link",
              icon: SeoHugeIcon,
            },
            // بلاغات جاهزية السكن
            hasAnyPermission([permissions.list_house_inspection_examination_periods]) && {
              title: "HOUSING_INSPECTION_REQUESTS_AND_REPORTS",
              path: `/app/makkah/buildings-not-inspected`,
              type: "link",
              icon: ParagraphBulletsPoint02HugeIcon,
            },
          ].filter(Boolean),
        },
        hasAnyPermission([
          permissions.list_pilgrim_data,
          permissions.view_accommodations,
          permissions.list_makkah_group_pilgrims_inquiry,
        ]) && {
          title: "PILGRIMS_AND_GROUPS",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            hasAnyPermission([permissions.list_pilgrim_data]) && {
              title: "PILGRIMS",
              path: `/app/makkah/pilgrims`,
              type: "link",
              icon: HajjHugeIcon,
            },
            hasAnyPermission([permissions.view_accommodations]) && {
              title: "CAMPAIGN_SETTLEMENT",
              path: `/app/makkah/campaign-settlement`,
              type: "link",
              icon: AddSquareHugeIcon,
            },
            hasAnyPermission([permissions.list_makkah_group_pilgrims_inquiry]) && {
              title: "GROUP_PILGRIMS_QUERY",
              path: `/app/makkah/group-pilgrims-query`,
              type: "link",
              icon: QuestionHugeIcon,
            },
          ].filter(Boolean),
        },
        hasAnyPermission([
          permissions.list_nusuk_cards_batchs,
          permissions.list_nusuk_cards_batch_returns,
          permissions.view_export_nusuk_cards_batch_report,
        ]) && {
          title: "NUSUK_CARDS",
          type: "sub",
          badge: true,
          active: false,
          children: [
            hasAnyPermission([permissions.list_nusuk_cards_batchs]) && {
              title: "NUSUK_CARDS_NEW_BATCHES",
              path: `/app/makkah/nusuk-cards`,
              type: "link",
              icon: StoreVerifiedHugeIcon,
            },
            hasAnyPermission([permissions.list_nusuk_cards_batch_returns]) && {
              title: "NUSUK_CARDS_BATCH_RETURNS",
              path: `/app/makkah/nusuk-cards/returns`,
              type: "link",
              icon: SquareArrowDataTransferDiagonalHugeIcon,
            },
            hasAnyPermission([permissions.list_nusuk_cards_batchs]) && {
              title: "NUSUK_CARDS_INQUIRY",
              path: `/app/makkah/nusuk-cards-inquiry`,
              type: "link",
              icon: SearchAreaHugeIcon,
            },
            hasAnyPermission([permissions.view_export_nusuk_cards_batch_report]) && {
              title: "NUSUK_CARDS_REPORTS",
              path: `/app/makkah/nusuk-cards-reports`,
              type: "link",
              icon: ComplaintHugeIcon,
            },
          ].filter(Boolean),
        },
        {
          title: "REPORTS_AND_INCIDENTS",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            {
              title: "INCIDENTS",
              path: `/app/makkah/incidents`,
              type: "link",
              icon: Alert01HugeIcon,
            },
            hasAnyPermission([permissions.list_makkah_incident_reports]) && {
              title: "REPORTS",
              path: `/app/makkah/reports`,
              type: "link",
              icon: WorkAlertHugeIcon,
            },
          ].filter(Boolean),
        },
        hasAnyPermission([
          permissions.list_initial_departure,
          permissions.list_departure_campaigns_index,
          permissions.list_departure_groups_index,
          permissions.list_flight_details,
          permissions.list_transport_contracts,
        ]) && {
          title: "DEPARTURE",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            hasAnyPermission([
              permissions.list_initial_departure
            ]) && {
              title: "PILGRIM_DEPARTURE",
              path: `/app/makkah/initial-departure-pilgrims`,
              type: "link",
              icon: Kaaba01HugeIcon,
            },
            hasAnyPermission([
              permissions.list_departure_campaigns_index
            ]) && {
              title: "CAMPAIGN_DEPARTURE",
              path: `/app/makkah/departure_campaigns`,
              type: "link",
              icon: CampaignsHugeIcon,
            },
            hasAnyPermission([
              permissions.list_departure_groups_index
            ]) && {
              title: "GROUPS_DEPARTURE",
              path: `/app/makkah/departure_groups`,
              type: "link",
              icon: GroupsHugeIcon,
            },
            hasAnyPermission([
              permissions.list_flight_details
            ]) && {
              title: "FLIGHTS",
              path: `/app/makkah/flights`,
              type: "link",
              icon: Airplane02HugeIcon,
            },
            hasAnyPermission([
              permissions.list_transport_contracts
            ]) && {
              title: "PRIVATE_TRANSPORT_CONTRACTS",
              path: `/app/makkah/private-transport-contracts`,
              type: "link",
              icon: LicenseHugeIcon,
            },
          ].filter(Boolean),
        },
        {
          title: "REPORTS_AND_STATISTICS",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            hasAnyPermission([
              permissions.makkah_view_export_campaign_group_pilgrims,
              permissions.view_pilgrim_report_not_coming_makkah,
              permissions.view_pilgrim_report_not_accommodated_makkah,
              permissions.view_pilgrim_report_nationality_stats_makkah,
              permissions.view_pilgrim_report_mission_stats_makkah,
            ]) && {
              title: "PILGRIM_REPORTS",
              path: `/app/makkah/pilgrim-reports`,
              type: "link",
              icon: ComplaintHugeIcon,
            },
            hasAnyPermission([
              permissions.view_export_makkah_arrival_campaign_segments_report,
              permissions.view_export_makkah_group_details_report,
              permissions.view_export_makkah_housed_arrivals_service_center_distribution_report,
              permissions.view_export_makkah_campaign_statement_report,
              permissions.view_export_makkah_group_statement_report,
            ]) && {
              title: "CAMPAIGN_AND_GROUP_REPORTS",
              path: `/app/makkah/campaigns-and-groups-reports`,
              type: "link",
              icon: AnalysisTextLinkHugeIcon,
            },
            {
              title: "RECEPTION_AND_ARRIVAL_REPORTS",
              path: `/app/makkah/reception-and-arrival-reports`,
              type: "link",
              icon: SquareArrowDataTransferDiagonalHugeIcon,
            },
            {
              title: "DEPARTURE_RQUEST_REPORTS",
              path: `/app/makkah/departure-reports`,
              type: "link",
              icon: Analytics01HugeIcon,
            },
            hasAnyPermission([
              permissions.view_export_housing_contract_detail_report,
              permissions.view_export_house_contract_campaigns_report,
              permissions.view_export_food_contracts_report,
              permissions.view_export_housing_comprehensive_detail_report,
              permissions.view_export_housing_building_delegate_detail_report,
            ]) && {
              title: "HOUSING_REPORTS",
              path: `/app/makkah/housing-reports`,
              type: "link",
              icon: Activity03HugeIcon,
            },
            hasAnyPermission([permissions.makkah_view_export_incident_reports]) && {
              title: "INCIDENT_AND_REPORT_LOGS",
              path: `/app/makkah/incident-and-report-logs`,
              type: "link",
              icon: AlertDiamondHugeIcon,
            },
            hasAnyPermission([permissions.makkah_view_export_incident_reports]) && {
              title: "COMPLIANCE_REPORTS",
              path: `/app/makkah/compliance-reports`,
              type: "link",
              icon: ManagerHugeIcon,
            },
            {
              title: "USERS_AND_SERVICE_CENTERS",
              path: `/app/makkah/users-and-service-centers`,
              type: "link",
              icon: UserIdVerificationHugeIcon,
            },
          ].filter(Boolean),
        },
        {
          title: "SYSTEM_MANAGEMENT",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            {
              title: "SERVICE_CENTERS",
              path: `/app/makkah/service-centers`,
              type: "link",
              icon: Location03HugeIcon,
            },
            hasAnyPermission([ROLES.super_admin]) && {
              title: "MASTER_DATA",
              path: `/app/makkah/basic-data/cities`,
              type: "link",
              icon: Settings01HugeIcon,
            },
            hasAnyPermission([ROLES.super_admin]) &&
            {
              title: "SYSTEM_SECURITY",
              path: `/app/makkah/system-security`,
              type: "link",
              icon: SecurityCheckHugeIcon,
            },
          ],
        },
        {
          title: "ARCHIVES",
          type: "sub",
          badge: true,
          active: false,
          children: [
            {
              title: "ARCHIVES",
              path: `/app/makkah/archives`,
              type: "link",
              badge: true,
              active: false,
              icon: Archive02HugeIcon,
            },
          ],
        },
      ].filter(Boolean),
    },
  ], [hasAnyPermission]);

  const MadinaPlatformMenuItems = useMemo(() => [
    {
      menutitle: "MADINA_DASHBOARD",
      Items: [
        // التخطيط والاستعداد المسبق
        {
          title: "MADINA_PLANNING_AND_PREPARATION",
          type: "sub",
          badge: true,
          active: false,
          children: [
            // {
            //   title: "MADINA_ORGANIZERS_AND_CONTRACTS",
            //   path: `/app/madina/organizers-and-contracts`,
            //   type: "link",
            // },
            // {
            //   title: "MADINA_VISAS",
            //   path: `/app/madina/visas`,
            //   type: "link",
            // },
            hasAnyPermission([
              permissions.list_campaigns_for_madina,
              permissions.view_campaigns_for_madina,
              permissions.create_campaigns_for_madina,
              permissions.update_campaigns_for_madina,
              permissions.delete_campaigns_for_madina,
              permissions.list_campaign_details_for_madina,
              permissions.view_campaign_details_for_madina,
              permissions.create_campaign_details_for_madina,
              permissions.update_campaign_details_for_madina,
              permissions.delete_campaign_details_for_madina,
              permissions.list_departure_campaigns_for_madina,
              permissions.view_departure_campaigns_for_madina,
              permissions.list_departure_campaign_details_for_madina,
              permissions.view_departure_campaign_details_for_madina,
              permissions.create_departure_campaign_details_for_madina,
              permissions.update_departure_campaign_details_for_madina,
              permissions.delete_departure_campaign_details_for_madina,
            ]) && {
              title: "CAMPAIGNS",
              path: hasAnyPermission([
                permissions.list_campaigns_for_madina,
                permissions.view_campaigns_for_madina,
                permissions.create_campaigns_for_madina,
                permissions.update_campaigns_for_madina,
                permissions.delete_campaigns_for_madina,
                permissions.list_campaign_details_for_madina,
                permissions.view_campaign_details_for_madina,
                permissions.create_campaign_details_for_madina,
                permissions.update_campaign_details_for_madina,
                permissions.delete_campaign_details_for_madina,
              ])
                ? `/app/madina/arrival-campaign`
                : `/app/madina/departure-campaign`,
              type: "link",
            },
            hasAnyPermission([
              permissions.list_groups_for_madina,
              permissions.view_groups_for_madina,
              permissions.create_groups_for_madina,
              permissions.update_groups_for_madina,
              permissions.delete_groups_for_madina,
              permissions.list_group_details_for_madina,
              permissions.view_group_details_for_madina,
              permissions.create_group_details_for_madina,
              permissions.update_group_details_for_madina,
              permissions.delete_group_details_for_madina,
            ]) && {
              title: "GROUPS",
              path: `/app/madina/groups-upcoming`,
              type: "link",
            },
            {
              title: "COMPLIANCE",
              path: `/app/madina/compliance`,
              type: "link",
            },
          ].filter(Boolean),
        },
        // استقبال المنافذ
        hasAnyPermission([
          permissions.list_port_reception_cards_from_nusk_for_madina,
          permissions.list_arrival_bags_for_madina,
        ]) && {
          title: "RECEPTIONـOFـPORTS",
          type: "sub",
          badge: true,
          active: false,
          children: [
            hasAnyPermission([permissions.list_port_reception_cards_from_nusk_for_madina]) && {
              title: "RECEPTION_MADINAH",
              path: `/app/madina/reception`,
              type: "link",
              icon: MosqueHugeIcon,
            },
            hasAnyPermission([permissions.list_arrival_bags_for_madina]) && {
              title: "BAGS",
              path: `/app/madina/bags`,
              type: "link",
              icon: Briefcase06HugeIcon,
            },
          ].filter(Boolean),
        },
        // استقبال المراكز
        hasAnyPermission([
          permissions.list_madina_reception_manifests,
          permissions.list_madina_reception_manifest_pilgrims,
          permissions.list_madina_reception_tafweejs,
          permissions.list_madina_reception_tafweej_pilgrims,
        ]) && {
          title: "CENTER_RECEPTION",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            hasAnyPermission([
              permissions.list_madina_reception_manifests,
              permissions.list_madina_reception_manifest_pilgrims,
              permissions.list_madina_reception_tafweejs,
              permissions.list_madina_reception_tafweej_pilgrims,
            ]) && {
              title: "CENTER_RECEPTION_MADINAH",
              path: `/app/madina/center-reception?source=from_ports&date=today`,
              type: "link",
              icon: RealEstateHugeIcon,
            },
          ].filter(Boolean),
        },
        // السكن والمساكن
        hasAnyPermission([
          permissions.list_housing_for_madina, permissions.list_housing_contracts_for_madina, 
          permissions.list_house_inspection_examinations_for_madina,
          permissions.list_house_inspection_orders_for_madina,
          permissions.list_house_inspection_track_cards_for_madina
        ]) && {
          title: "MADINA_HOUSING_AND_ACCOMMODATIONS",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            // المســاكـن
            hasAnyPermission([permissions.list_housing_for_madina]) && {
              title: "MADINA_HOUSING",
              path: `/app/madina/housing-permits`,
              type: "link",
              icon: LicenseThirdPartyHugeIcon,
            },
            // عقــود السكن
            hasAnyPermission([permissions.list_housing_contracts_for_madina]) && {
              title: "MADINA_HOUSING_CONTRACTS",
              path: `/app/madina/housing-contracts`,
              type: "link",
              icon: ScrollHugeIcon,
            },
            // فحص جاهزية السكن
            hasAnyPermission([permissions.list_house_inspection_examinations_for_madina]) && {
              title: "HOUSING_INSPECTION",
              path: `/app/madina/housing-inspection`,
              type: "link",
              icon: StoreVerifiedHugeIcon,
            },
            // اوامر فحص السكن
            hasAnyPermission([permissions.list_house_inspection_orders_for_madina]) && {
              title: "HOUSING_INSPECTION_MONITORING",
              path: `/app/madina/housing-inspection-orders`,
              type: "link",
              icon: SearchAreaHugeIcon,
            },
            // ملاحظات فحص السكن
            hasAnyPermission([permissions.list_house_inspection_track_cards_for_madina]) && {
              title: "FOLLOW_UP_READINESS_REPORTS",
              path: `/app/madina/housing-inspection-notes`,
              type: "link",
              icon: SeoHugeIcon,
            },
          ].filter(Boolean),
        },
        // الحجاج
        {
          title: "PILGRIMS",
          type: "sub",
          badge: true,
          active: false,
          children: [
            {
              title: "PILGRIMS",
              path: `/app/madina/pilgrims`,
              type: "link",
              icon: HajjHugeIcon,
            },
          ],
        },
        hasAnyPermission([
          permissions.list_nusuk_cards_batchs_madina,
          permissions.list_nusuk_cards_batch_returns_madina,
          permissions.view_export_nusuk_cards_batch_report_madina,
          permissions.list_nusuk_cards_batchs_madina,
        ]) && {
          title: "NUSUK_CARDS",
          type: "sub",
          badge: true,
          active: false,
          children: [
            hasAnyPermission([permissions.list_nusuk_cards_batchs_madina]) && {
              title: "NUSUK_CARDS_NEW_BATCHES",
              path: `/app/madina/nusuk-cards`,
              type: "link",
              icon: StoreVerifiedHugeIcon,
            },
            hasAnyPermission([permissions.list_nusuk_cards_batch_returns_madina]) && {
              title: "NUSUK_CARDS_BATCH_RETURNS",
              path: `/app/madina/nusuk-cards/returns`,
              type: "link",
              icon: SquareArrowDataTransferDiagonalHugeIcon,
            },
            hasAnyPermission([permissions.list_nusuk_cards_batchs_madina]) && {
              title: "NUSUK_CARDS_INQUIRY",
              path: `/app/madina/nusuk-cards-inquiry`,
              type: "link",
              icon: SearchAreaHugeIcon,
            },
            hasAnyPermission([permissions.view_export_nusuk_cards_batch_report_madina]) && {
              title: "NUSUK_CARDS_REPORTS",
              path: `/app/madina/nusuk-cards-reports`,
              type: "link",
              icon: ComplaintHugeIcon,
            },
          ].filter(Boolean),
        },
        {
          title: "MADINA_REPORTS_AND_INCIDENTS",
          type: "sub",
          badge: true,
          active: false,
          children: [
            {
              title: "MADINA_INCIDENTS",
              path: `/app/madina/incidents`,
              type: "link",
            },
            hasAnyPermission([permissions.list_madina_incident_reports]) && {
              title: "MADINA_REPORTS",
              path: `/app/madina/reports`,
              type: "link",
            },
          ].filter(Boolean),
        },
        hasAnyPermission([
          permissions.list_initial_departure_for_madina,
          permissions.list_departure_campaigns_index_for_madina,
          permissions.list_departure_groups_index_for_madina,
          permissions.list_flight_details_for_madina,
          permissions.list_transport_contracts_for_madina,
        ]) && {
          title: "MADINA_DEPARTURE",
          type: "sub",
          badge: true,
          active: false,
          // children: [
          //   {
          //     title: "MADINA_FLIGHTS",
          //     path: `/app/madina/flights`,
          //     type: "link",
          //   },
          //   {
          //     title: "MADINA_PRIVATE_TRANSPORT_CONTRACTS",
          //     path: `/app/madina/private-transport-contracts`,
          //     type: "link",
          //   },
          //   {
          //     title: "MADINA_PILGRIM_PRELIMINARY_DEPARTURE",
          //     path: `/app/madina/pilgrim-preliminary-departure`,
          //     type: "link",
          //   },
          // ],
          children: [
            hasAnyPermission([
              permissions.list_initial_departure_for_madina
            ]) && {
              title: "PILGRIM_DEPARTURE",
              path: `/app/madina/initial-departure-pilgrims`,
              type: "link",
              icon: Kaaba01HugeIcon,
            },
            hasAnyPermission([
              permissions.list_departure_campaigns_index_for_madina
            ]) && {
              title: "CAMPAIGN_DEPARTURE",
              path: `/app/madina/departure_campaigns`,
              type: "link",
              icon: CampaignsHugeIcon,
            },
            hasAnyPermission([
              permissions.list_departure_groups_index_for_madina
            ]) && {
              title: "GROUPS_DEPARTURE",
              path: `/app/madina/departure_groups`,
              type: "link",
              icon: GroupsHugeIcon,
            },
            hasAnyPermission([
              permissions.list_flight_details_for_madina
            ]) && {
              title: "FLIGHTS",
              path: `/app/madina/flights`,
              type: "link",
              icon: Airplane02HugeIcon,
            },
            hasAnyPermission([
              permissions.list_transport_contracts_for_madina
            ]) && {
              title: "PRIVATE_TRANSPORT_CONTRACTS",
              path: `/app/madina/private-transport-contracts`,
              type: "link",
              icon: LicenseHugeIcon,
            },
          ].filter(Boolean),
        },
        // التـقـارير واالحصائيات
        {
          title: "MADINA_REPORTS_AND_STATISTICS",
          type: "sub",
          badge: true,
          active: false,
          children: [
            // تقارير الحجاج
            hasAnyPermission([
              permissions.view_pilgrim_report_not_coming_madina,
              permissions.view_pilgrim_report_not_accommodated_madina,
              permissions.madina_view_export_campaign_group_pilgrims,
            ]) && {
              title: "PILGRIM_REPORTS",
              path: `/app/madina/pilgrim-reports`,
              type: "link",
            },
            // تقارير الحملات والمجموعات
            hasAnyPermission([
              permissions.view_export_madina_arrival_campaign_segments_report,
              permissions.view_export_madina_group_details_report,
              permissions.view_export_madina_housed_arrivals_service_center_distribution_report,
              permissions.view_export_madina_campaign_statement_report,
              permissions.view_export_madina_group_statement_report,
            ]) && {
              title: "MADINA_CAMPAIGN_AND_GROUP_REPORTS",
              path: `/app/madina/campaigns-and-groups-reports`,
              type: "link",
            },
            // تقارير الاستقبال والقـدوم
            {
              title: "MADINA_RECEPTION_AND_ARRIVAL_REPORTS",
              path: `/app/madina/reception-and-arrival-reports`,
              type: "link",
            },
            // تقارير طلب مغادرة
            {
              title: "DEPARTURE_RQUEST_REPORTS",
              path: `/app/madina/departure-reports`,
              type: "link",
            },
            // تقارير الاسكان
            hasAnyPermission([
              permissions.view_export_housing_contract_detail_report_for_madina,
              permissions.view_export_food_contracts_report_for_madina,
              permissions.view_export_house_contract_campaigns_report_for_madina,
              permissions.view_export_housing_comprehensive_detail_report_for_madina,
              permissions.view_export_housing_building_delegate_detail_report_for_madina,
            ]) && {
              title: "HOUSING_REPORTS",
              path: `/app/madina/housing-reports`,
              type: "link",
            },
            hasAnyPermission([permissions.madina_view_export_incident_reports]) && {
              title: "MADINA_INCIDENT_AND_REPORT_LOGS",
              path: `/app/madina/incident-and-report-logs`,
              type: "link",
            },
            hasAnyPermission([permissions.view_export_madina_incident_reports_report]) && {
              title: "MADINA_COMPLIANCE_REPORTS",
              path: `/app/madina/compliance-reports`,
              type: "link",
            },
            {
              title: "MADINA_USERS_AND_SERVICE_CENTERS",
              path: `/app/madina/users-and-service-centers`,
              type: "link",
            },
          ].filter(Boolean),
        },
        hasAnyPermission([ROLES.super_admin]) && {
          title: "SYSTEM_MANAGEMENT",
          type: "sub",
          badge: true,
          active: false,
          children: [
            hasAnyPermission([ROLES.super_admin]) &&{
              title: "MASTER_DATA",
              path: `/app/madina/basic-data/cities`,
              type: "link",
              icon: Settings01HugeIcon,
            },
            hasAnyPermission([ROLES.super_admin]) &&
            {
              title: "SYSTEM_SECURITY",
              path: `/app/madina/system-security`,
              type: "link",
              icon: SecurityCheckHugeIcon,
            },
          ].filter(Boolean),
        },
      ],
    },
  ], [hasAnyPermission]);
  const UsersManagementMenuItems = useMemo(() => [
    {
      menutitle: "USERS_DASHBOARD",
      Items: [
        {
          title: "SYSTEM_USERS",
          path: `/app/user_management/users`,
          type: "link",
          icon: UserUnlock01HugeIcon,
        },
        {
          title: "GROUPS",
          path: `/app/user_management/groups`,
          type: "link",
          icon: UserGroup03HugeIcon,
        },
      ],
    },
  ], []);

  const SeasonalRecruitmentMenuItems = useMemo(() => [
    {
      menutitle: "SEASONAL_RECRUITMENT_PLATFORM_SHORT",
      Items: [
        {
          title: "SYSTEM_MANAGEMENT",
          type: "sub",
          badge: true,
          active: false,
          children: [
            hasAnyPermission([ROLES.super_admin]) && {
              title: "MASTER_DATA",
              path: `/app/seasonal_hr/basic-data/qualifications`,
              type: "link",
              icon: Settings01HugeIcon,
            },
          ].filter(Boolean),
        },
      ],
    },
  ], [hasAnyPermission]);

  return {
    makkah: MakkahMenuItems,
    user_management: UsersManagementMenuItems,
    madina: MadinaPlatformMenuItems,
    seasonal_hr: SeasonalRecruitmentMenuItems,
  }
};

// Icons can be added to menu items - if undefined, pseudo-element styles will be used
const MakkahMenuItems = [
  {
    menutitle: "MAKKAH_DASHBOARD",
    Items: [
      {
        title: "PLANNING_AND_PREPARATION",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "ORGANIZERS_AND_CONTRACTS",
            path: `/app/makkah/organizers-and-contracts`,
            type: "link",
            icon: ServiceHugeIcon,
          },
          {
            title: "VISAS",
            path: `/app/makkah/visas`,
            type: "link",
            icon: ValidationApprovalHugeIcon,
          },
          {
            title: "CAMPAIGNS",
            path: `/app/makkah/arrival-campaign`,
            type: "link",
            icon: CampaignsHugeIcon,
          },
          {
            title: "GROUPS",
            path: `/app/makkah/groups-upcoming`,
            type: "link",
            icon: GroupsHugeIcon,
          },
          {
            title: "CAMPS",
            path: `/app/makkah/camps`,
            type: "link",
            icon: CottageHugeIcon,
          },
          {
            title: "COMPLIANCE",
            path: `/app/makkah/compliance`,
            type: "link",
            icon: PolicyHugeIcon,
          },
        ],
      },
      {
        title: "RECEPTIONـOFـPORTS",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "RECEPTION_MAKKAH",
            path: `/app/makkah/JED/reception`,
            type: "link",
            icon: RealEstateHugeIcon,
          },
        ],
      },
      {
        title: "CENTER_RECEPTION",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "CENTER_RECEPTION_MAKKAH_ORGANIZER",
            path: `/app/makkah/JED/center-reception`,
            type: "link",
            icon: RealEstateHugeIcon,
          },
          {
            title: "NUSUK_RECEPTION_MAKKAH",
            path: `/app/makkah/MED/center-reception?source=from_ports&date=today`,
            type: "link",
            icon: MosqueHugeIcon,
          },
        ],
      },
      {
        title: "HOUSING_AND_ACCOMMODATIONS",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "HOUSING",
            path: `/app/makkah/housing-permits`,
            type: "link",
            icon: LicenseThirdPartyHugeIcon,
          },
          {
            title: "HOUSING_CONTRACTS",
            path: `/app/makkah/housing-contracts`,
            type: "link",
            icon: ScrollHugeIcon,
          },
          {
            title: "HOUSING_INSPECTION",
            path: `/app/makkah/housing-inspection`,
            type: "link",
            icon: StoreVerifiedHugeIcon,
          },
          {
            title: "HOUSING_INSPECTION_MONITORING",
            path: `/app/makkah/housing-inspection-orders`,
            type: "link",
            icon: SearchAreaHugeIcon,
          },
          {
            title: "FOLLOW_UP_READINESS_REPORTS",
            path: `/app/makkah/housing-inspection-notes`,
            type: "link",
            icon: SeoHugeIcon,
          },
          // {
          //   title: "BUILDINGS_NOT_INSPECTED",
          //   path: `/app/makkah/buildings-not-inspected`,
          //   type: "link",
          //   icon: Building03HugeIcon,
          // },
          {
            title: "HOUSING_INSPECTION_REQUESTS_AND_REPORTS",
            path: `/app/makkah/buildings-not-inspected`,
            type: "link",
            icon: ParagraphBulletsPoint02HugeIcon,
          },
        ],
      },
      {
        title: "PILGRIMS_AND_GROUPS",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "PILGRIMS",
            path: `/app/makkah/pilgrims`,
            type: "link",
            icon: HajjHugeIcon,
          },
          {
            title: "CAMPAIGN_SETTLEMENT",
            path: `/app/makkah/campaign-settlement`,
            type: "link",
            icon: AddSquareHugeIcon,
          },
          {
            title: "GROUP_PILGRIMS_QUERY",
            path: `/app/makkah/group-pilgrims-query`,
            type: "link",
            icon: QuestionHugeIcon,
          },
        ],
      },
      {
        title: "NUSUK_CARDS",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "NUSUK_CARDS_NEW_BATCHES",
            path: `/app/makkah/nusuk-cards`,
            type: "link",
            icon: StoreVerifiedHugeIcon,
          },
          {
            title: "NUSUK_CARDS_BATCH_RETURNS",
            path: `/app/makkah/nusuk-cards/returns`,
            type: "link",
            icon: SquareArrowDataTransferDiagonalHugeIcon,
          },
          {
            title: "NUSUK_CARDS_INQUIRY",
            path: `/app/makkah/nusuk-cards-inquiry`,
            type: "link",
            icon: SearchAreaHugeIcon,
          },
          {
            title: "NUSUK_CARDS_REPORTS",
            path: `/app/makkah/nusuk-cards-reports`,
            type: "link",
            icon: ComplaintHugeIcon,
          }
        ],
      },
      {
        title: "REPORTS_AND_INCIDENTS",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "INCIDENTS",
            path: `/app/makkah/incidents`,
            type: "link",
            icon: Alert01HugeIcon,
          },
          {
            title: "REPORTS",
            path: `/app/makkah/reports`,
            type: "link",
            icon: WorkAlertHugeIcon,
          },
        ],
      },
      {
        title: "DEPARTURE",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "PILGRIM_DEPARTURE",
            path: `/app/makkah/initial-departure-pilgrims`,
            type: "link",
            icon: Kaaba01HugeIcon,
          },
          {
            title: "CAMPAIGN_DEPARTURE",
            path: `/app/makkah/departure_campaigns`,
            type: "link",
            icon: CampaignsHugeIcon,
          },
          {
            title: "GROUPS_DEPARTURE",
            path: `/app/makkah/departure_groups`,
            type: "link",
            icon: GroupsHugeIcon,
          },
          {
            title: "FLIGHTS",
            path: `/app/makkah/flights`,
            type: "link",
            icon: Airplane02HugeIcon,
          },
          {
            title: "PRIVATE_TRANSPORT_CONTRACTS",
            path: `/app/makkah/private-transport-contracts`,
            type: "link",
            icon: LicenseHugeIcon,
          },
        ],
      },
      {
        title: "REPORTS_AND_STATISTICS",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "PILGRIM_REPORTS",
            path: `/app/makkah/pilgrim-reports`,
            type: "link",
            icon: ComplaintHugeIcon,
          },
          {
            title: "CAMPAIGN_AND_GROUP_REPORTS",
            path: `/app/makkah/campaign-and-group-reports`,
            type: "link",
            icon: AnalysisTextLinkHugeIcon,
          },
          {
            title: "RECEPTION_AND_ARRIVAL_REPORTS",
            path: `/app/makkah/reception-and-arrival-reports`,
            type: "link",
            icon: SquareArrowDataTransferDiagonalHugeIcon,
          },
          {
            title: "DEPARTURE_RQUEST_REPORTS",
            path: `/app/makkah/departure-reports`,
            type: "link",
            icon: Analytics01HugeIcon,
          },
          {
            title: "HOUSING_REPORTS",
            path: `/app/makkah/housing-reports`,
            type: "link",
            icon: Activity03HugeIcon,
          },
          {
            title: "INCIDENT_AND_REPORT_LOGS",
            path: `/app/makkah/incident-and-report-logs`,
            type: "link",
            icon: AlertDiamondHugeIcon,
          },
          {
            title: "COMPLIANCE_REPORTS",
            path: `/app/makkah/compliance-reports`,
            type: "link",
            icon: ManagerHugeIcon,
          },
          {
            title: "USERS_AND_SERVICE_CENTERS",
            path: `/app/makkah/users-and-service-centers`,
            type: "link",
            icon: UserIdVerificationHugeIcon,
          },
        ],
      },
      {
        title: "SYSTEM_MANAGEMENT",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "SERVICE_CENTERS",
            path: `/app/makkah/service-centers`,
            type: "link",
            icon: Location03HugeIcon,
          },
          {
            title: "MASTER_DATA",
            path: `/app/makkah/basic-data/cities`,
            type: "link",
            icon: Settings01HugeIcon,
          },
          {
            title: "SYSTEM_SECURITY",
            path: `/app/makkah/system-security`,
            type: "link",
            icon: SecurityCheckHugeIcon,
          },
        ],
      },
      {
        title: "ARCHIVES",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "ARCHIVES",
            path: `/app/makkah/archives`,
            type: "link",
            badge: true,
            active: false,
            icon: Archive02HugeIcon,
          },
        ],
      },
    ],
  },
];
const MadinaPlatformMenuItems = [
  {
    menutitle: "MADINA_DASHBOARD",
    Items: [
      {
        title: "MADINA_PLANNING_AND_PREPARATION",
        type: "sub",
        badge: true,
        active: false,
        children: [
          // {
          //   title: "MADINA_ORGANIZERS_AND_CONTRACTS",
          //   path: `/app/madina/organizers-and-contracts`,
          //   type: "link",
          // },
          // {
          //   title: "MADINA_VISAS",
          //   path: `/app/madina/visas`,
          //   type: "link",
          // },
          {
            title: "CAMPAIGNS",
            path: `/app/madina/arrival-campaign`,
            type: "link",
          },
          {
            title: "GROUPS",
            path: `/app/madina/groups-upcoming`,
            type: "link",
          },
          {
            title: "COMPLIANCE",
            path: `/app/madina/compliance`,
            type: "link",
          },
        ],
      },
      {
        title: "RECEPTIONـOFـPORTS",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "RECEPTION_MADINAH",
            path: `/app/madina/reception`,
            type: "link",
            icon: MosqueHugeIcon,
          },
          {
            title: "BAGS",
            path: `/app/madina/bags`,
            type: "link",
            icon: Briefcase06HugeIcon,
          },
        ],
      },
      {
        title: "CENTER_RECEPTION",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "CENTER_RECEPTION_MADINAH",
            path: `/app/madina/center-reception?source=from_ports&date=today`,
            type: "link",
            icon: RealEstateHugeIcon,
          },
        ],
      },
      {
        title: "MADINA_HOUSING_AND_ACCOMMODATIONS",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "MADINA_HOUSING",
            path: `/app/madina/housing-permits`,
            type: "link",
            icon: LicenseThirdPartyHugeIcon,
          },
          {
            title: "MADINA_HOUSING_CONTRACTS",
            path: `/app/madina/housing-contracts`,
            type: "link",
            icon: ScrollHugeIcon,
          },
          {
            title: "HOUSING_INSPECTION",
            path: `/app/madina/housing-inspection`,
            type: "link",
            icon: StoreVerifiedHugeIcon,
          },
          {
            title: "HOUSING_INSPECTION_MONITORING",
            path: `/app/madina/housing-inspection-orders`,
            type: "link",
            icon: SearchAreaHugeIcon,
          },
          {
            title: "FOLLOW_UP_READINESS_REPORTS",
            path: `/app/madina/housing-inspection-notes`,
            type: "link",
            icon: SeoHugeIcon,
          },
        ],
      },
      {
        title: "PILGRIMS",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "PILGRIMS",
            path: `/app/madina/pilgrims`,
            type: "link",
            icon: HajjHugeIcon,
          },
        ],
      },
      {
        title: "NUSUK_CARDS",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "NUSUK_CARDS_NEW_BATCHES",
            path: `/app/madina/nusuk-cards`,
            type: "link",
            icon: StoreVerifiedHugeIcon,
          },
          {
            title: "NUSUK_CARDS_BATCH_RETURNS",
            path: `/app/madina/nusuk-cards/returns`,
            type: "link",
            icon: SquareArrowDataTransferDiagonalHugeIcon,
          },
          {
            title: "NUSUK_CARDS_INQUIRY",
            path: `/app/madina/nusuk-cards-inquiry`,
            type: "link",
            icon: SearchAreaHugeIcon,
          },
          {
            title: "NUSUK_CARDS_REPORTS",
            path: `/app/madina/nusuk-cards-reports`,
            type: "link",
            icon: ComplaintHugeIcon,
          }
        ],
      },
      {
        title: "MADINA_REPORTS_AND_INCIDENTS",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "MADINA_INCIDENTS",
            path: `/app/madina/incidents`,
            type: "link",
          },
          {
            title: "MADINA_REPORTS",
            path: `/app/madina/reports`,
            type: "link",
          },
        ],
      },
      {
        title: "MADINA_DEPARTURE",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "MADINA_FLIGHTS",
            path: `/app/madina/flights`,
            type: "link",
          },
          {
            title: "MADINA_PRIVATE_TRANSPORT_CONTRACTS",
            path: `/app/madina/private-transport-contracts`,
            type: "link",
          },
          {
            title: "MADINA_PILGRIM_PRELIMINARY_DEPARTURE",
            path: `/app/madina/pilgrim-preliminary-departure`,
            type: "link",
          },
        ],
      },
      {
        title: "MADINA_REPORTS_AND_STATISTICS",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "PILGRIM_REPORTS",
            path: `/app/madina/pilgrim-reports`,
            type: "link",
          },
          {
            title: "MADINA_CAMPAIGN_AND_GROUP_REPORTS",
            path: `/app/madina/campaign-and-group-reports`,
            type: "link",
          },
          {
            title: "MADINA_RECEPTION_AND_ARRIVAL_REPORTS",
            path: `/app/madina/reception-and-arrival-reports`,
            type: "link",
          },
          {
            title: "DEPARTURE_RQUEST_REPORTS",
            path: `/app/madina/departure-reports`,
            type: "link",
          },
          {
            title: "HOUSING_REPORTS",
            path: `/app/madina/housing-reports`,
            type: "link",
          },
          {
            title: "MADINA_INCIDENT_AND_REPORT_LOGS",
            path: `/app/madina/incident-and-report-logs`,
            type: "link",
          },
          {
            title: "MADINA_COMPLIANCE_REPORTS",
            path: `/app/madina/compliance-reports`,
            type: "link",
          },
          {
            title: "MADINA_USERS_AND_SERVICE_CENTERS",
            path: `/app/madina/users-and-service-centers`,
            type: "link",
          },
        ],
      },
      {
        title: "SYSTEM_MANAGEMENT",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "MASTER_DATA",
            path: `/app/madina/basic-data/cities`,
            type: "link",
            icon: Settings01HugeIcon,
          },
        ],
      },
    ],
  },
];
const UsersManagementMenuItems = [
  {
    menutitle: "USERS_DASHBOARD",
    Items: [
      {
        title: "SYSTEM_USERS",
        path: `/app/user_management/users`,
        type: "link",
        icon: UserUnlock01HugeIcon,
      },
      {
        title: "GROUPS",
        path: `/app/user_management/groups`,
        type: "link",
        icon: UserGroup03HugeIcon,
      },
    ],
  },
];

const SeasonalRecruitmentMenuItems = [
  {
    menutitle: "SEASONAL_RECRUITMENT_PLATFORM_SHORT",
    Items: [
      {
        title: "SYSTEM_MANAGEMENT",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "MASTER_DATA",
            path: `/app/seasonal_hr/basic-data/qualifications`,
            type: "link",
            icon: Settings01HugeIcon,
          },
        ],
      },
    ],
  },
];

export const platformMenuItems = {
  makkah: MakkahMenuItems.filter(Boolean),
  user_management: UsersManagementMenuItems.filter(Boolean),
  madina: MadinaPlatformMenuItems.filter(Boolean),
  seasonal_hr: SeasonalRecruitmentMenuItems.filter(Boolean),
};

